<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="订单编号" prop="orderNo">
              <a-input v-model="formInline.orderNo" placeholder="请输入订单编号">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="用户uid" prop="userUid">
              <a-input
                v-model="formInline.userUid"
                type="user"
                placeholder="请输入用户uid"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <seckillOrderContentTwo
          ref="aaa"
          :formInline="formInline"
        ></seckillOrderContentTwo>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import seckillOrderContentTwo from "./seckillOrderContentTwo.vue";
export default {
  components: {
    seckillOrderContentTwo,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        userUid: "",
        endDate: "",
        startDate: "",
        limit: 10,
        page: 1,
      },
    };
  },
  updated() {
    // this.formInline.orderNo = "";
    // this.formInline.userUid = "";

  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    resetForm() {
      this.$refs.aaa.getData();
      this.formInline = {
        orderNo: "",
        userUid: "",
        endDate: "",
        startDate: "",
        limit: 10,
        page: 1,
      };
    },
    seach() {
      this.$refs.aaa.query();
    },
    onChange(date, dateString) {
      console.log(dateString);
      this.formInline.endDate = dateString[1];
      this.formInline.startDate = dateString[0];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/seckillOrderTwo/seckillOrderHomeTwo.vue